<template>
  <Container :active='5'>
    <div class="mainbody">
      <div class="menu">
        <div class="menu-item" :class='{active:activeCode == menu.Code}' v-for='menu in issues' @click='select(menu.Code)'>
          <Icon type="ios-paper" class='icon'></Icon>{{menu.Name}}
        </div>
      </div>
      <div class="content">
          <div  class="list">
            <template v-for='menu in issues' v-if='activeCode == menu.Code'>
               <Collapse v-model="value1" accordion simple>
                  <Panel :name="subItem.Code" v-for='subItem in menu.subItems'>
                      <p class="panel-title" :style='{color:value1 == subItem.Code?"#B176C5":""}'>{{subItem.Title}}</p>
                      <p class="show-content" slot="content" v-html='content.Content'></p>
                  </Panel>
              </Collapse>
            </template>
          </div>
      </div>
    </div>
        </div>
  </Container>
</template>
<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'
export default {
  data() {
    return {
      issues: null,
      content:{},
      show: true,
      activeCode:null,
      value1:null,
    }
  },
  created() {
    this.$nextTick(function() {
      this.initData()
    })
  },
  mounted() {

  },
  watch: {
    value1(value){
      this.showContent(value[0])
    },
    activeCode(){
        this.content = {}
        this.value1 = ''
    }
  },
  mixins: [],
  components: {},
  computed: {
    ...mapState({

    }),
  },
  methods: {
    ...mapActions([
      'getCommunityCatalogAction',
      'getCommunityListAction',
      'getCommunityArticleAction',
    ]),
    isValid(item) {
      let now = new Date
      let valid = true
      if (item.validFrom) {
        valid = now >= item.validFrom
      }
      if (item.validTo) {
        valid = now <= item.validTo
      }
      return valid
    },
    async initData() {
      let response = await this.getCommunityCatalogAction('DT_WS_HelpCatalog')
      let params = {
        code: 'Help',
        depth: 0,
        keys: '',
        StartIndex:1,
        PageSize: 10000,
      }
      let response1 = await this.getCommunityListAction(params)
      if(response.length&&response1.length){
        let categories = response
        response.forEach(category => {
          category.subItems = []
          response1.forEach(item=>{
            if(item.Model == category.Code){
              category.subItems.push(item)
            }
          })
        });
      }
      console.log(response)
      this.issues = response
      this.activeCode = this.issues[0].Code
    },
    showNav() {
      this.show = !this.show
    },
    async showContent(Code){
      this.content = {}
      this.content  = await this.getCommunityArticleAction({Code})
    },
    async select(Code) {
      this.activeCode = Code
      this.show = false
    },
    showItem(bid, sid) {
      if (this.showIndex == sid) {
        this.showIndex = -1;
      } else {
        this.showIndex = sid;
        this.$router.push({
          path: '/show/help',
          query: {
            q: `${bid}-${sid}`,
          }
        })
      }

    },
    update(name) {
      let [index1, index2] = name.split('-')
      this.selCategory = this.issues[index1 - 1]
      console.log(this.selCategory)
      this.showIndex = index2;
      this.open_name = name.split('-')[0];
      this.active_name = name;
      this.$nextTick(function() {
        this.$refs.helpMenu.updateOpened()
        this.$refs.helpMenu.updateActiveName()
      })
    },

  },
}

</script>
<style lang='scss' scoped>
@import 'src/style/common';

.container {

  // margin: auto;
  .mainbody {
    margin: auto;
    margin-top: 20px;
    display: flex;
    max-width: 1200px;

    .menu {
      width: 2.4rem;
      max-height: 100vh;
      overflow-y:scroll;
      .menu-item {
        cursor: pointer;
        padding: 14px 24px;
        border-right: 1px solid #ddd;
        .icon {
          margin-right: 6px;
        }
      }
      .active {
        color: #B176C5;
        background: #fef0ff;
        border-right: 2px solid #B176C5;
      }
    }

    .content {
      flex: 1;
      max-width: 800px;
      margin-left: 40px;
      margin-bottom: 20px;
      .panel-title {
          display: -webkit-box;
          -webkit-line-clamp: 1;//向显示多少行就给多大值
          -webkit-box-orient: vertical; 
          overflow: hidden;
        }
        ::v-deep .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
          display: flex;
          line-height: initial;
          align-items: center;
        }
      .show-content {
        margin-left: 30px;
      }
    }
  }
}

.list {
  margin-top: 20px;
}

@media (max-width:768px) {

  .container {
    width: 95%;
    .mainbody {
      .menu {
        width: 100px;
        .menu-item {
          padding: 14px 7px;
          @include fontSize($font-size-12);
        }
        
        .icon {
          display:none;
        }
      }
      .content {
        margin-left: 0;
        display: block;
        width: 100%;
        @include fontSize($font-size-12);
        padding-left: 0;
      }
    }
  }
}

</style>
